Routes = window.Routes || {};

$(function () {
  rwgps.Events.bind("metrics:changed", Routes.Common.updateMetrics);

  const sel = '#cue_sheet_preview tr, .cue_sheet_preview tr';
  $(document).on('mouseenter', sel, function() {
    var $this = $(this);
    var cp = $this.data("coursepoint");
    if(cp === undefined) return;
    $('#cue_sheet_preview tr, .cue_sheet_preview tr').css({'background-color': ''});
    $this.css({'background-color': '#E7E7E7','cursor': 'pointer'});

    if(Routes.activeMap) {
      Routes.activeMap.callWhenReady(function() { Routes.activeMap.openCoursePointInfoWindow(cp, false) });
    }
  }).on('mouseleave', sel, function() {
    var $this = $(this);
    $this.css({'background-color': ''});

    if(Routes.activeMap) {
      Routes.activeMap.callWhenReady(function() { Routes.activeMap.closePreviewInfoWindow() });
    }
  }).on('click', sel, function() {
    var $this = $(this);
    Routes.activeMap.callWhenReady(function() {
      Routes.activeMap.openCoursePointInfoWindow($this.data("coursepoint"), true);
    });
    $('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
    $this.addClass('openCoursePointInfo');
  });
});



Routes.Common = {
  pois: [],
  onMapCleared: function() {
    this.pois = [];
  },
  geocodeResult: function(countryCode, administrativeArea, locality, postalCode) {
    var geo = {country_code: countryCode, administrative_area: administrativeArea, locality: locality, postal_code: postalCode};
    $('#geodata').val(JSON.stringify(geo));
  },
  getRouteViewerOptions: function() {
    var optsArray = [];
    var i = 0;
    $('#options input[type="checkbox"]').each(function(){
      optsArray[i] = $(this).val() + ":" + $(this).attr('checked');
      i++;
    })
    return optsArray;
  },
  resizeMap: function() {
    var offset = $('.globalNav').get(0).getClientRects()[0].top + $('.globalNav').outerHeight();
    var wh = window.innerHeight ? window.innerHeight-offset : $(window).height()-offset;

    var tipsHeight = $('#page_tips:visible').height() || 0;

    $('.fullpage_left_col,.fullpage_right_col').height(wh);
    $('#map,#new_route_map').height(wh);
    if ($('#save_route_form').length != 0) {
      $('.fullpage_left_col,.fullpage_right_col').css('height', $(window).height()-offset);
    }
    if ($('.sidebar_pages').length != 0) {
      $('.sidebar_pages').each(function() {
        var buffer = $(this).offset().top - offset;
        $(this).height(wh-buffer);
        if ($(this).parents('.fullpage_left_col').length > 0){
          $(this).height(wh-buffer-tipsHeight);
        }
      });
    }
    if ($('.fullpage_right_col .sidebar_pages').length != 0) {
      if ($('#playback_container').length) {
        $('.fullpage_right_col .sidebar_pages').height(wh-153);
      }
    }
    rwgps.Events.trigger('resizeMap:after');
  },
  populateCoursePoints: function(course_points, append) {
    var $cuesheet_table = $('#cue_sheet_preview, .cue_sheet_preview');
    //since we change background of only recently appended notes, fix old ones
    $cuesheet_table.find("td").css({"background-color": "#FFFFFF"});
    if(!append) { $cuesheet_table.empty(); }
    if(course_points == null) return;
    for(var i = 0; i < course_points.length; i++) {
      $cuesheet_table.append(Routes.Common.createCoursePointRow(course_points[i], append));
    }
  },
  createCoursePointRow: function(cp, append) {
    $('#start_drawing_for_cue_sheet').hide();
    var $row = $('<tr><td>' + _.escape(cp['notes']) + '</td><td>' +
      rwgps.LabelMaker.longLabel(cp['distance'], true) + '</td></tr>');
    if(append) $row.find("td").css({"background-color": "#E7E7E7"});
    $row.data("coursepoint", cp);
    cp.row = $row;
    return $row;
  },
	prevCoursePointInfo: function(prevCPI) {
		$('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
		$('#'+prevCPI).addClass('openCoursePointInfo');
	},
	nextCoursePointInfo: function(nextCPI) {
		$('#cue_sheet_preview tr, .cue_sheet_preview tr').removeClass('openCoursePointInfo');
		$('#'+nextCPI).addClass('openCoursePointInfo');
	},
  updateMetrics: function(metrics, zoomedIn) {
    if(!metrics || !metrics.v) return;
    if(zoomedIn)
      $('.hide_zoomed_out').show();

    if(metrics == null) {
      metrics = { };
    }

    $('.changesOnZoom').toggleClass('zoomed_in', !!zoomedIn);

    if(metrics.hasOwnProperty('cad') && metrics.cad.avg) {
      $("#maxCad").text(metrics.cad.max + " rpm");
      if(metrics.cad.max_i)
        $("#maxCad").data('i', metrics.cad.max_i);
      $("#minCad").text(metrics.cad.min + " rpm");
      if(metrics.cad.min_i)
        $("#minCad").data('i', metrics.cad.min_i);
      $("#avgCad").text(metrics.cad.avg.toFixed(1) + " rpm");
    }
    if(metrics.hasOwnProperty('hr') && metrics.hr.avg) {
      $("#maxHr").text(Math.round(metrics.hr.max) + " bpm");
      if(metrics.hr.max_i)
        $("#maxHr").data('i', metrics.hr.max_i);
      $("#minHr").text(Math.round(metrics.hr.min) + " bpm");
      if(metrics.hr.min_i)
        $("#minHr").data('i', metrics.hr.min_i);
      $("#avgHr").text(metrics.hr.avg.toFixed(1) + " bpm");
    }
    if(metrics.hasOwnProperty('watts') && metrics.watts.avg) {
      $("#maxWatts").text(Math.round(metrics.watts.max));
      if(metrics.watts.max_i)
        $("#maxWatts").data('i', metrics.watts.max_i);
      $("#avgWattsWith0s").text(Math.round(metrics.watts._avg));
      $("#avgWatts").text(Math.round(metrics.watts.avg));
      $("#normalizedPower").text(Math.round(metrics.watts.normalized));
      $("#workKJ").text(Math.round(metrics.kJ) + ' kJ');
    }
    if(metrics.hasOwnProperty('speed') && metrics.speed.avg) {
      $("#maxSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.max, true));
      if(metrics.speed.max_i)
        $("#maxSpeed").data('i', metrics.speed.max_i);
      $("#minSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.min, true));
      if(metrics.speed.min_i)
        $("#minSpeed").data('i', metrics.speed.min_i);
      $("#avgSpeed").text(rwgps.LabelMaker.speedLabel(metrics.speed.avg, true));
    }

    if(metrics.hasOwnProperty('distance')) {
      $(".txtDistance").text(rwgps.LabelMaker.longLabel(metrics.distance, true));
    } else {
      $(".txtDistance").text("");
    }
    if(!metrics.distance) {
      $('.hide_unless_distance').hide();
    } else {
      $('.hide_unless_distance').show();
    }
    if(metrics.hasOwnProperty('ele_gain') && metrics.hasOwnProperty('ele_loss') && !isNaN(metrics.ele_loss) && !(metrics.ele_gain == 0 && metrics.ele_loss == 0)) {
      $('.hide_unless_ele').show();
      $(".txtAscent").text(rwgps.LabelMaker.shortLabel(metrics.ele_gain, false));
      $(".txtDescent").text(rwgps.LabelMaker.shortLabel(metrics.ele_loss, true));
    } else {
      $('.hide_unless_ele').hide();
    }
    if(metrics.hasOwnProperty('vam')) {
      $(".txtVam").text(Math.round(metrics.vam) + ' Vm/h');
      if(Math.round(metrics.vam)==0)
        $('.vamRow').hide();
      else
        $('.vamRow').show();
    } else {
      $('.vamRow').hide();
    }
    if(metrics.hasOwnProperty('ascentTime')) {
      $(".txtAscentTime").text(rwgps.LabelMaker.durationLabel(metrics.ascentTime));
      if(metrics.ascentTime == 0)
        $('.ascentRow').hide();
      else
        $('.ascentRow').show();
    }
    if(metrics.hasOwnProperty('descentTime')) {
      $(".txtDescentTime").text(rwgps.LabelMaker.durationLabel(metrics.descentTime));
      if(metrics.descentTime == 0)
        $('.descentRow').hide();
      else
        $('.descentRow').show();
    }
    if(metrics.hasOwnProperty('duration') && metrics.duration) {
      $('#duration').text(rwgps.LabelMaker.durationLabel(metrics.duration));
      $('#movingTime').text(rwgps.LabelMaker.durationLabel(metrics.movingTime));
      $('#stoppedTime').text(rwgps.LabelMaker.durationLabel(metrics.stoppedTime));
    }
    if(metrics.hasOwnProperty('pace') && metrics.pace && metrics.movingPace) {
      $('#pace').text(rwgps.LabelMaker.paceLabel(metrics.pace));
      $('#movingPace').text(rwgps.LabelMaker.paceLabel(metrics.movingPace));
    }
    $('.txtTrackPoints').text(metrics.numPoints || 0);
    try {
      $('.txtCoursePoints').text(Routes.activeMap.activeRoute.coursePoints().length);
    } catch(e) {
      $('.txtCoursePoints').text("");
    }
    if(metrics.hasOwnProperty('ele')) {
      $('.txtMinElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.min, true));
      $('.txtMaxElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.max, true));
      $('.txtAvgElevation').text(rwgps.LabelMaker.shortLabel(metrics.ele.avg, true));
    } else {
      $('.txtMinElevation').text("");
      $('.txtMaxElevation').text("");
      $('.txtAvgElevation').text("");
    }
    if(metrics.hasOwnProperty('startElevation') && !isNaN(metrics.startElevation))
      $('.txtStartElevation').text(rwgps.LabelMaker.shortLabel(metrics.startElevation, true));
    else
      $('.txtStartElevation').text("");
    if(metrics.hasOwnProperty('endElevation') && !isNaN(metrics.endElevation))
      $('.txtFinishElevation').text(rwgps.LabelMaker.shortLabel(metrics.endElevation, true));
    else
      $('.txtFinishElevation').text("");
    if(metrics.hasOwnProperty('grade')) {
      if(metrics.grade.max) {
        $('.txtMaxGrade').text(metrics.grade.max.toFixed(1) + " %");
        if(metrics.grade.max_i)
          $(".txtMaxGrade").data('i', metrics.grade.max_i);
      }
      if(metrics.grade.avg)
        $('.txtAvgGrade').text(metrics.grade.avg.toFixed(1) + " %");
    } else {
      $('.txtMaxGrade').text('0 %');
      $('.txtAvgGrade').text('0 %');
    }
    if(metrics.isClimb) {
      $('.hide_unless_climb').show();
      $('.txtCat').text(metrics.uciCategory);
      $('.txtFiets').text(metrics.fietsIndex.toFixed(2));
    } else {
      $('.hide_unless_climb').hide();
    }
    if(metrics.estimatedTime) {
      $('.hide_unless_estimatedTime').show();
      $('.txtEstimatedTime').text(rwgps.LabelMaker.durationLabel(metrics.estimatedTime));
    } else {
      $('.hide_unless_estimatedTime').hide();
    }
    if(!zoomedIn)
      $('.hide_zoomed_out').hide();
  },

  populateTipOfTheDay: function () {
    var index = Math.floor(Math.random() * Routes.Common.tipsOfTheDay.length);
    var tip = Routes.Common.tipsOfTheDay[index];

    $('#tip_link').attr('href', tip.link);
    if (tip.link === ''){
      $('#tip_link').hide();
    }

    $('#tip_text').text(tip.tip);
  }
};

Routes.Common.tipsOfTheDay = [
  {
    'tip': 'When planning or viewing a route, click and drag on the elevation profile to zoom in on a specific section of your route. Click the Edit link that appears to access advanced tools.',
    'link': 'https://ridewithgps.com/help/the-elevation-profile-for-routes'
  },
  {
    'tip': "By changing the map style, you can switch between maps that focus on different information. Different styles use different routing data. If you get stuck while planning, or don't see a trail you want, switching your map style may help.",
    'link': 'https://ridewithgps.com/help/switching-map-styles'
  },
  {
    'tip': 'Change the rules of the road by switching routing optimizations in the right hand sidebar. Don’t be afraid to try walking and driving modes, they can help route around obstructions. Click below to learn more about the different modes.',
    'link': 'https://ridewithgps.com/help/planning#optimize-for'
  },
  {
    'tip': 'To join two routes together, click the Add Route button at the top of the left sidebar. Once your desired route is added to the map, join them by clicking the green dot. You can route from the end of one to the start of another by clicking on the map like usual.',
    'link': 'https://ridewithgps.com/help/combining-and-splitting-routes#combining'
  },
  {
    'tip': "To split a route, click and drag on the elevation profile then click the Edit link that appears. You'll be able to then remove the selected section. The remaining route sections can be saved as separate routes, or you can reconnect them in a different way.",
    'link': 'https://ridewithgps.com/help/combining-and-splitting-routes#splitting'
  },
  {
    'tip': 'Add Points of Interest (POI) to your map by clicking the Add POI button in the right sidebar, then clicking anywhere on the map. POI are shown on printed maps and cuesheets, as well as our mobile app during navigation.',
    'link': 'https://ridewithgps.com/help/point-of-interest-pois#adding'
  },
  {
    'tip': 'Change the color of a section of your route by clicking and dragging the elevation profile, then clicking the Edit link. Select the change color option, or one of the other editing tools.',
    'link': 'https://ridewithgps.com/help/edit-color-on-a-section-of-route'
  },
  {
    'tip': 'To delete a section of your route, click and drag on the elevation profile on the section you wish to delete, then click the Edit link. If you delete a selection in the middle of your route, you can re-join the remaining sections in a new way, or you can save them as separate routes.',
    'link': 'https://ridewithgps.com/help/the-elevation-profile-for-routes#edit'
  },
  {
    'tip': 'You can click and drag your route to edit it. Mouse over the route, then click and drag the blue dot. Click below to learn how to control how much of your route changes when clicking and dragging.',
    'link': 'https://ridewithgps.com/help/planning#add-remove-control-points'
  },
  {
    'tip': 'Add custom cues by clicking the Add to Cuesheet button in the right sidebar, then clicking the blue dot seen while mousing along your route. These cues will be available on printed maps and when navigating using the Ride with GPS app, a Garmin unit, or a Wahoo ELEMNT.',
    'link': 'https://ridewithgps.com/help/edit-cue-sheet'
  },
  {
    'tip': 'Use the Draw Lines button in the right sidebar to switch from following roads and paths to drawing straight lines between clicks. This is helpful when working with trails that are not routable, or when dealing with unusual intersections or parking lots.',
    'link': 'https://ridewithgps.com/help/planning#drawlines'
  },
  {
    'tip': 'Do you like keyboard shortcuts? If so, hit shift-? to get a cheat sheet of route planner hotkeys.',
    'link': 'https://ridewithgps.com/routes/new#hotkey_modal'
  },
  {
    'tip': 'See more of your map by collapsing the right and left sidebars. Simply click the << and >> icons near the top of the sidebars to collapse them. Click the same icons to re-open them when you need to access route planning tools.'
  }
]



// WEBPACK FOOTER //
// ./public/javascripts/routes/common.js